import setBroadcast from 'actions/Broadcast/setBroadcast';

function limitedBroadcastUpdated({ dispatch }, payload) {
  dispatch(setBroadcast(payload));
}

export default limitedBroadcastUpdated;
